export enum PauseServicNameEnum {
  VITAL_MONITORING = 'Vitals Monitoring',
  VISIT_SERVICE = 'Visit Service',
  BILLING = 'Billing',
}
